import { render } from "./HomePrescription.vue?vue&type=template&id=0025bfb5&lang=true"
import script from "./HomePrescription.vue?vue&type=script&lang=js"
export * from "./HomePrescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__